module.exports = __webpack_public_path__ + "static/icons/icon-chevron-left-1578a333ca6f45d4189e9b11567c069b.svg";